package com.ives.modules.compare;

import com.er453r.hxcompo.Component;
import com.ives.components.thumb.DicomThumb;
import com.ives.modules.info.Info;
import com.ives.utils.Log;
import com.ives.utils.Remoting.DicomImageData;
import js.html.DragEvent;

class OpenedSeries extends Component {
	private var dicomImageData:DicomImageData;

	public function new(dicomImageData:DicomImageData, closable:Bool, onClose:DicomImageData->Void) {
		this.dicomImageData = dicomImageData;

		date.innerHTML = DateTools.format(Date.fromTime(dicomImageData.studyDate), "%Y/%m/%d %H:%M") + '<br/>' + Info.fillMissing(dicomImageData.institutionName);

		if(!closable)
			closeOpenedSeries.style.display = "none";

		closeOpenedSeries.addEventListener("click", function(){
			onClose(dicomImageData);
		});
	}
}
